export const minPhotoHeight = 152;
export const DEFAULT_PHOTO_TOOL_PHOTO_WIDTH = 232;
export const photoGap = 24;

export const photoToolDefaultPageSize = 50;
export const photoToolPageSizeOptions: [number, ...Array<number>] = [20, 50, 100, 150];
export const PHOTO_TOOL_SCROLL_POSIITON = 'photoToolScrollPosition';
export const PHOTO_TOOL_HIGHLIGTH_PHOTO_ID = 'photoToolHighlightPhotoId';
